import { render } from "./skeltonTitles.vue?vue&type=template&id=96bb5178"
import script from "./skeltonTitles.vue?vue&type=script&lang=js"
export * from "./skeltonTitles.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__